import { useEffect, useState } from "react";
import { FileSpreadsheet, TrendingUp, Trophy, Star, ShoppingBag } from "lucide-react";
import { api, API } from "../../lib/api";

const opts = { withCredentials: true };
const thisMonth = () => new Date().toISOString().slice(0, 7);
const xaf = (n) => `${(n || 0).toLocaleString("fr-FR").replace(/\u202f|\u00a0/g, " ")} F CFA`;

const Card = ({ icon: Icon, label, value, sub, testid }) => (
  <div data-testid={testid} className="border border-[#D1CFC7] bg-[#FAF9F6] p-4">
    <p className="flex items-center gap-2 text-[10px] tracking-[0.2em] uppercase text-[#757575]"><Icon size={13} className="text-[#9E4735]" /> {label}</p>
    <p className="font-serif text-2xl text-[#1A1A1A] mt-2 leading-tight">{value}</p>
    {sub && <p className="text-xs text-[#757575] mt-1">{sub}</p>}
  </div>
);

export const SalesDashboard = ({ refreshKey }) => {
  const [month, setMonth] = useState(thisMonth());
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/ebook-sales/stats", { ...opts, params: { month } }).then((r) => setS(r.data)).catch(() => setS(null)); }, [month, refreshKey]);
  const label = new Date(`${month}-01T12:00:00`).toLocaleDateString("fr-FR", { month: "long", year: "numeric" });

  return (
    <section data-testid="sales-dashboard" className="mb-8 font-body">
      <div className="flex flex-wrap items-center gap-3 mb-4">
        <label className="text-xs text-[#4A4A4A] flex items-center gap-2">Mois
          <input type="month" value={month} onChange={(e) => e.target.value && setMonth(e.target.value)} data-testid="sales-month-input" className="bg-[#FAF9F6] border border-[#D1CFC7] px-2 py-1.5 text-sm" />
        </label>
        <a href={`${API}/admin/ebook-sales/export?month=${month}`} data-testid="sales-export-month" className="flex items-center gap-2 border border-[#2C402E] text-[#2C402E] hover:bg-[#2C402E] hover:text-[#FAF9F6] px-3 py-1.5 text-xs transition-colors"><FileSpreadsheet size={14} /> Excel du mois</a>
        <a href={`${API}/admin/ebook-sales/export`} data-testid="sales-export-all" className="flex items-center gap-2 border border-[#D1CFC7] text-[#4A4A4A] hover:border-[#2C402E] px-3 py-1.5 text-xs transition-colors"><FileSpreadsheet size={14} /> Excel de toutes les ventes</a>
        <span className="text-[11px] text-[#757575]">Numérique + commandes papier au statut « Livrée » (date de commande)</span>
      </div>
      {s && (
        <>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
            <Card icon={TrendingUp} label={`Chiffre d'affaires · ${label}`} value={xaf(s.revenue)} sub={`Numérique ${xaf(s.digital_revenue)} · Papier ${xaf(s.paper_revenue)}`} testid="sales-revenue" />
            <Card icon={ShoppingBag} label="Ventes" value={s.count} sub={`${s.digital_count} numérique(s) · ${s.paper_count} papier livré(s)`} testid="sales-count" />
            <Card icon={Trophy} label="Livre le plus vendu" value={s.top ? s.top.title : "—"} sub={s.top ? `${s.top.count} vente(s) · ${xaf(s.top.revenue)}` : null} testid="sales-top-book" />
            <Card icon={Star} label="Note moyenne" value={s.avg_rating ? `${s.avg_rating} / 5` : "—"} sub={`${s.reviews} avis`} testid="sales-avg-rating" />
          </div>
          {s.by_book.length > 0 && (
            <ul data-testid="sales-by-book" className="mt-3 text-xs text-[#4A4A4A] space-y-1">
              {s.by_book.map((b) => <li key={b.title} className="flex flex-wrap justify-between gap-2 border-b border-[#E8E4D9] py-1"><span>{b.title}</span><span>Numérique {b.digital_count} · Papier {b.paper_count} · <strong>{xaf(b.revenue)}</strong></span></li>)}
            </ul>
          )}
          {s.by_partner?.length > 0 && (
            <div data-testid="sales-by-partner" className="mt-5">
              <p className="text-[10px] tracking-[0.2em] uppercase text-[#757575] mb-2">Ventes par partenaire (lieu du QR code)</p>
              <ul className="text-xs text-[#4A4A4A] space-y-1">
                {s.by_partner.map((p) => <li key={p.name} data-testid={`sales-partner-${p.name}`} className="flex flex-wrap justify-between gap-2 border-b border-[#E8E4D9] py-1"><span>{p.name}</span><span>Numérique {p.digital_count} · Papier {p.paper_count} · <strong>{xaf(p.revenue)}</strong></span></li>)}
              </ul>
            </div>
          )}
        </>
      )}
    </section>
  );
};
